import { useState } from "react"
import { useNavigate } from 'react-router-dom';
import "../assets/styles/homepage.css"

const Homepage = () => {
  const [selectedNumber, setSelectedNumber] = useState(0)

  // const handleNumberClick = (number) => {
  //   setSelectedNumber(number)
  //   console.log(`Selected day: ${number}`)
  // }

  const navigate = useNavigate();

  const handleNumberClick = (number) => {
    navigate(`/menu/${number}`);
  };

  const handleBackClick = () => {
    navigate("/");
  };

  const numbers = [0, 1, 2, 3, 4, 5, 6, 7]

  const getNumberBoxClass = (number) => {
    const isSelected = selectedNumber === number
    return `number-box number-box-${number} ${isSelected ? 'selected' : ''}`
  }

  const getNumberTextClass = (number) => {
    const isSelected = selectedNumber === number
    return `number-text ${isSelected ? 'selected' : ''}`
  }

  return (
    <div className="home-page">
      {/* Header */}
      <div className="header">
      <div className="back-arrow" onClick={() => navigate("/")}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M15 18L9 12L15 6" stroke="#CCA4CC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </div>
        <div className="homepage-day-title">Day</div>
      </div>

      {/* Connection Lines */}
      <div className="connection-lines">
        <div className="vector-line vector-43"></div>
        <div className="vector-line vector-44"></div>
        <div className="vector-line vector-45"></div>
        <div className="vector-line vector-46"></div>
        <div className="vector-line vector-47"></div>
        <div className="vector-line vector-48"></div>
        <div className="vector-line vector-49"></div>
      </div>

      {/* Number Boxes */}
      <div className="number-boxes">
        {numbers.map((number) => (
          <div 
            key={number} 
            className={getNumberBoxClass(number)} 
            onClick={() => handleNumberClick(number)}
          >
            <span className={getNumberTextClass(number)}>{number}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Homepage